module.exports = __webpack_public_path__ + "img/tray-dish-svgrepo-com (3).0966bfad.svg";